import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {UserNode} from '../../../core/user/user.model';
import {UserService} from '../../../core/user/user.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AppService} from '../../../app.service';

@Component({
    selector: 'quick-access',
    templateUrl: './quick-access.component.html',
    styleUrls: ['./quick-access.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class QuickAccessComponent implements OnInit
{
    @Input() position: 'top' | 'middle' = 'top';

    user: UserNode;

    menu: any = [];

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _userService: UserService,
        public appService: AppService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user) => {
                this.user = user;
            });

        this.checkQuickAccessPermissions();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /** Check quick access permissions
     *
     */
    checkQuickAccessPermissions(): void {
        if (this.appService.hasPermission('send_bills_view')) {
            this.menu.push({
                name: 'Envio de contas',
                icon: 'paper-plane',
                link: '/envio-de-contas'
            });
        }

        if (this.appService.hasPermission('unpaid_bill_view')) {
            this.menu.push({
                name: 'Contas a pagar',
                icon: 'accounting',
                link: '/contas-a-pagar'
            });
        }

        if (this.appService.hasPermission('statement_view')) {
            this.menu.push({
                name: 'Extrato',
                icon: 'growth',
                link: '/extrato'
            });
        }

        if (this.appService.hasPermission('debtor_view')) {
            this.menu.push({
                name: 'Devedores',
                icon: 'businessman',
                link: '/devedores'
            });
        }

        if (this.appService.hasPermission('digital_folder_view')) {
            this.menu.push({
                name: 'Pasta digital',
                icon: 'folder-open',
                link: '/pasta-digital'
            });
        }
    }
}
